/**
 *
 * Splash
 *
 * splash
 *
 */
import PropTypes from "prop-types";

function Splash(props) {
  return (
    <div className="step" id="Splash">
      <h1>This website provides EU citizens a way to provisionally ‘opt-out’ from the EHDS</h1>
      <p1>Our mission is provide all EU citizens with a means to object to being registred in the European Health Data Space (EHDS). Please in by clicking <em>&quot;Select Country&quot;</em>  if it is available for your country or checkout the the <em>&quot;about&quot;</em> button  for more info.</p1>

      {/* Buttons */}
      <div className="buttonsRow">
        <div
          className="buttonDefault"
          onClick={(e) => props.emitChangeSection("about", e)}
        >
          about
        </div>
        <div
          className="buttonDefault"
          onClick={(e) => props.emitChangeSection("selectCountry", e)}
        >
          Select country
        </div>
      </div>
    </div>
  );
}

Splash.propTypes = {
  emitChangeSection: PropTypes.func, // Change step
};

export default Splash;
